export const EMAIL_REGEX=/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// 16桁以下半角英数字
export const PASSWORD_REGEXP_PATTERN_1=/^[a-zA-Z0-9]{1,16}$/;
// 8文字以上半角英数字、16桁以下
export const PASSWORD_REGEXP_PATTERN_2=/^[a-zA-Z0-9]{8,16}$/;
// 8~16文字以上数字、半角英文字の組み合わせ
export const PASSWORD_REGEXP_PATTERN_3=/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,16}$/;

export type USER_LANGUAGE = "ja" | "ko" | "en";
export type USER_CURRENCY = "jpy" | "krw" | "usd";
export type USER_CURRENCY_MARK = "￥" | " ₩" | "＄";
export const CURRENCY_MARK = {
  "non": " ",
  "jpy": "￥",
  "krw": "₩",
  "usd": "＄"
};

export const DEFAULT_LANGUAGE = "ja";
export const DEFAULT_CURRENCY = "jpy";
